import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import store from "./store";
import vuetify from "./plugins/vuetify";

import "@mdi/font/css/materialdesignicons.css";
Vue.use(vuetify, { iconfont: "mdi" });

Vue.config.productionTip = false;

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
